import { connect } from 'react-redux';

import { getOfficesShortList } from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import RouteMap from './RouteMap';
import {
  getRouteMapLocations,
  getSingleEmployeeClockInOutList,
  getTaskCheckInOutList,
} from './routeMapActions';
import { getGeofenceLocations } from 'custom_modules/GeofenceLocations/geofenceLocationsActions';

const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  // loading
  locationsIsLoading: state.routeMap.locationsIsLoading,

  routeMapLocations: state.routeMap.routeMapLocations,
  clockInOutList: state.routeMap.clockInOutList,
  taskCheckInOutList: state.routeMap.taskCheckInOutList,
  lastAttendanceTimestamp: state.routeMap.lastAttendanceTimestamp,
  geofenceLocations: state.geofenceLocations.geofenceLocations,
});

const mapDispatchToProps = dispatch => ({
  getRouteMapLocations: payload => dispatch(getRouteMapLocations(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getOrganizationMembersList: payload =>
    dispatch(getOrganizationMembersList(payload)),
  getSingleEmployeeClockInOutList: payload =>
    dispatch(getSingleEmployeeClockInOutList(payload)),
  getTaskCheckInOutList: payload => dispatch(getTaskCheckInOutList(payload)),
  getGeofenceLocations: payload => dispatch(getGeofenceLocations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteMap);
